import React from "react";
import {
  Badge,
  Box,
  Button,
  Chip,
  Container,
  Grid,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import Autocomplete from "@mui/material/Autocomplete";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation } from "react-router-dom";
import { openModal } from "../../../business/redux/reducers/modal/actions";
import { FilterAltOutlined } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { TaskListFilterContent } from "../../modal/informationModal/contents/taskListFilterContent";
import { setTaskGraphsFilterParams } from "../../../business/redux/reducers/filter/actions";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { HeaderIconsSection } from "../headerIconsSection";

const options = [
  "Long Distance",
  "Mid Distance",
  "Short Distance",
  "Local",
  "International",
];

export const HeaderMiddleSection = ({ open }) => {
  const [jobType, setJobType] = React.useState([]);
  const [dateFilter, setDateFilter] = React.useState("all_times");
  const location = useLocation();
  const handleChange = (event, newDateFilter) => {
    setDateFilter(newDateFilter);
  };

  const dispatch = useDispatch();

  const { filters } = useSelector((s) => s);

  const { leadFilter, taskGraphsFilterParams } = filters;
  const filterCount = Object.keys(leadFilter).reduce((acc, curr) => {
    return Array.isArray(leadFilter[curr])
      ? acc + leadFilter[curr].length
      : acc + Number(!!leadFilter[curr]);
  }, 0);

  return (
    <>
      <Container
        className="statistic_filter_container"
        maxWidth="false"
        style={{ backgroundColor: "#fff", padding: "5px 8px" }}
      >
        <Grid container direction="row" alignItems="center">
          <Grid
            item
            container
            direction="row"
            xs={2}
            sx={{ py: 0, px: 1 }}
            alignItems="center"
          >
            <HeaderIconsSection />
          </Grid>
          <Grid
            item
            container
            direction="row"
            xs={10}
            sx={{ py: 0, px: 1 }}
            alignItems="center"
            justifyContent="flex-end"
          >
            {location.pathname === "/tasks-list" && (
              <>
                <Autocomplete
                  className="select_move_types"
                  sx={{ "& .MuiInputBase-root": { py: 0 } }}
                  multiple
                  popupIcon={<KeyboardArrowDownIcon />}
                  options={options}
                  value={jobType}
                  onChange={(event, newValue) => setJobType(newValue)}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option}
                        {...getTagProps({ index })}
                        key={option}
                        deleteIcon={<CloseIcon />}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      sx={{
                        fieldset: { border: "none" }, // Убираем рамку
                        "& .MuiChip-root": {
                          height: "26px",
                          borderRadius: "0 !important",
                        },
                      }}
                      placeholder={jobType.length == 0 ? "Select job type" : ""}
                    />
                  )}
                />
                <Box
                  display="flex"
                  alignItems="center"
                  sx={{ my: 2, ml: 2, mr: 4 }}
                >
                  <ToggleButtonGroup
                    color="primary"
                    value={dateFilter}
                    exclusive
                    onChange={handleChange}
                    aria-label="date_filter_btns"
                  >
                    <ToggleButton
                      variant="text"
                      className="chip_filter_btn"
                      sx={{ mx: 1 }}
                      value="all_times"
                    >
                      All times
                    </ToggleButton>
                    <ToggleButton
                      variant="text"
                      className="chip_filter_btn"
                      sx={{ mx: 1 }}
                      value="this_year"
                    >
                      This year
                    </ToggleButton>
                    <ToggleButton
                      variant="text"
                      className="chip_filter_btn"
                      sx={{ mx: 1 }}
                      value="this_week"
                    >
                      This week
                    </ToggleButton>
                    <ToggleButton
                      variant="text"
                      className="chip_filter_btn"
                      sx={{ mx: 1 }}
                      value="last_30_days"
                    >
                      Last 30 days
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Box>
              </>
            )}
            <Box>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    className="date_picker_field"
                    label="Since"
                    format="DD, MMMM, YYYY"
                    slots={{
                      openPickerIcon: CalendarMonthOutlinedIcon,
                    }}
                    value={taskGraphsFilterParams.from}
                    onChange={(e) =>
                      dispatch(setTaskGraphsFilterParams({ from: e }))
                    }
                  />
                  <DatePicker
                    className="date_picker_field"
                    label="Until"
                    format="DD, MMMM, YYYY"
                    slots={{
                      openPickerIcon: CalendarMonthOutlinedIcon,
                    }}
                    value={taskGraphsFilterParams.to}
                    onChange={(e) =>
                      dispatch(setTaskGraphsFilterParams({ to: e }))
                    }
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>
            <Box display={"flex"} sx={{ p: 1, ml: 3 }}>
              <Button
                sx={{ mr: 0 }}
                className="Campaign_btn"
                onClick={() =>
                  dispatch(
                    openModal({
                      content: <TaskListFilterContent />,
                      style: { width: "780px" },
                    })
                  )
                }
              >
                <Badge
                  badgeContent={filterCount} // TODO check this
                  color="primary"
                  sx={{ mr: 2 }}
                  className="filter_count"
                >
                  <FilterAltOutlined sx={{ fontSize: "24px" }} />
                </Badge>{" "}
                filters
              </Button>
              <Typography
                variant="div"
                component="span"
                className="count_campaign_step count_campaign_step_right"
              >
                1
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
